import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import BaseCard from './BaseCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons';
import {
  customError,
  dimGrey,
  inactive,
  warningYellow,
} from '../../../mainTheme';

interface IssuesCardProps {
  isSelected?: boolean;
  onClick?: () => void;
  data: {
    total: number;
    highPriority: number;
    lowPriority: number;
  };
}

export const IssuesCard: React.FC<IssuesCardProps> = ({
  isSelected,
  onClick,
  data,
}) => {
  return (
    <BaseCard
      title="Issues"
      isSelected={isSelected}
      onClick={onClick}
      icon={<FontAwesomeIcon icon={faTriangleExclamation} color={dimGrey} />}
      totalCount={`${data.total} total`}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          mt: '16px',
        }}
      >
        <Box display="flex" flexDirection="column" gap="5.3px">
          <LinearProgress
            variant="determinate"
            value={
              data.total === 0 ? 0 : (data.highPriority / data.total) * 100
            }
            sx={{
              height: '6px',
              bgcolor: inactive,
              borderRadius: '7.5px',
              '& .MuiLinearProgress-bar': {
                backgroundColor: customError,
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px',
              }}
            >
              High priority
            </Typography>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: '16px',
              }}
            >
              {data.highPriority}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap="5.3px">
          <LinearProgress
            variant="determinate"
            value={data.total === 0 ? 0 : (data.lowPriority / data.total) * 100}
            sx={{
              height: '6px',
              bgcolor: inactive,
              borderRadius: '7.5px',
              '& .MuiLinearProgress-bar': {
                backgroundColor: warningYellow,
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px',
              }}
            >
              Low priority
            </Typography>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: '16px',
              }}
            >
              {data.lowPriority}
            </Typography>
          </Box>
        </Box>
      </Box>
    </BaseCard>
  );
};
